import React, { Component } from 'react';
import PropTypes from 'prop-types';

const iconSize = {
  small: "empty-state__icon--small",
  large: "empty-state__icon--large",
}

const spacing = {
  small: "empty-state__spacing--small",
  large: "empty-state__spacing--large",
}

class EmptyState extends Component {
  render() {
    return (
      <div className={`page__empty-state ${this.props.spacing} ${this.props.className ? this.props.className : ''}`}>
        {this.props.icon && 
          <div className={`page__empty-state__icon ${this.props.iconSize}`}>
            <i className={this.props.icon}></i>
          </div>
        }
        <div className="page__empty-state__message">
          {this.props.title && 
            <h2>{this.props.title}</h2>
          }
          {this.props.message && 
            <p>{this.props.message}</p>
          }
        </div>
        {this.props.children &&
          <div className="page__empty-state__footer">
            {this.props.children}
          </div>
        }
      </div>
    );
  }
}

EmptyState.iconSize = iconSize;
EmptyState.spacing = spacing;

EmptyState.propTypes = {
  className: PropTypes.string,
  iconSize: PropTypes.oneOf(Object.values(iconSize)),
  spacing: PropTypes.oneOf(Object.values(spacing)),
  icon: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.any,
  children: PropTypes.any,
};

EmptyState.defaultProps = {
    iconSize: EmptyState.iconSize.small,
    spacing: EmptyState.spacing.small,
};

export default EmptyState;
